import React, { useState, useEffect, useMemo } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { apiHolder as api } from 'api';
import DefaultMailMenuConfig from './DefaultMailMenuConfig';
import { FLOLDER, MAIL_MENU_ITEM } from '../../../constant';
import { findAndMergeDefaultMenuConfig, getShowByFolder, taskMailMenuShow } from '../util';
import lodashGet from 'lodash/get';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import { getIn18Text } from 'api';
import { getMailFromMails } from '@web-mail/util';
import IconCard from '@web-common/components/UI/IconCard';
const eventApi = api.api.getEventApi();
const systemApi = api.api.getSystemApi();
const ReadMailIconMenuConfig = findAndMergeDefaultMenuConfig([
    {
        key: MAIL_MENU_ITEM.BACK,
        icon: React.createElement(IconCard, { type: "arrowDown", stroke: "#3C3F47" }),
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.RE_EDIT,
        icon: undefined,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.MAIL_WITHDRAW,
        icon: undefined,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.MAIL_WITHDRAW_RES,
        icon: undefined,
        group: '2',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY,
        icon: undefined,
        group: '3',
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.REPLAY,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.REPLAY_ATTACH,
                icon: undefined,
            },
        ], DefaultMailMenuConfig),
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ALL,
        icon: undefined,
        group: '3',
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.REPLAY_ALL,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.REPLAY_ATTACH_ALL,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.REPLAY_ALL_AS_NEW,
                icon: undefined,
            },
        ], DefaultMailMenuConfig),
    },
    {
        key: MAIL_MENU_ITEM.FORWARD,
        icon: undefined,
        group: '3',
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.FORWARD,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.FORWARD_BY_ATTACH,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.DELIVERY,
                icon: undefined,
                show: (mails, defaultShow) => {
                    var _a;
                    const mail = getMailFromMails(mails);
                    if (!(process.env.BUILD_ISEDM || ((_a = systemApi === null || systemApi === void 0 ? void 0 : systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion))) {
                        return !!defaultShow && defaultShow(mail);
                    }
                    return false;
                },
                onClick: (mails, defaultClickFn) => {
                    const mail = getMailFromMails(mails);
                    const { entry: { id, threadMessageFirstId }, _account, isThread, } = mail;
                    let mailId = id;
                    if (isThread) {
                        mailId = threadMessageFirstId;
                    }
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {
                            mailId,
                            account: _account,
                            way: 'mailTop',
                        },
                        eventStrData: 'delivery',
                    });
                    defaultClickFn && defaultClickFn(mail);
                },
            },
        ], DefaultMailMenuConfig),
    },
    {
        key: MAIL_MENU_ITEM.DELIVERY,
        icon: undefined,
        group: '3',
        show: (mails, defaultShow) => {
            var _a;
            const mail = getMailFromMails(mails);
            if (process.env.BUILD_ISEDM || ((_a = systemApi === null || systemApi === void 0 ? void 0 : systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion)) {
                return !!defaultShow && defaultShow(mail);
            }
            return false;
        },
        onClick: (mails, defaultClickFn) => {
            const mail = getMailFromMails(mails);
            const { entry: { id, threadMessageFirstId }, _account, isThread, } = mail;
            let mailId = id;
            if (isThread) {
                mailId = threadMessageFirstId;
            }
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {
                    mailId,
                    account: _account,
                    way: 'mailTop',
                },
                eventStrData: 'delivery',
            });
            defaultClickFn && defaultClickFn(mail);
        },
    },
    {
        key: MAIL_MENU_ITEM.MARK,
        icon: undefined,
        group: '4',
        name: getIn18Text('BIAOJI'),
        onlyUnfold: true,
        show: true,
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.RED_FLAG,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.READ,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.TAG,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.WMFOLLOW,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.DEFER,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.COMMENT,
                icon: undefined,
            },
        ], DefaultMailMenuConfig),
    },
    {
        key: MAIL_MENU_ITEM.MOVE,
        icon: undefined,
        group: '4',
    },
    {
        key: MAIL_MENU_ITEM.TOP,
        icon: undefined,
        group: '4',
    },
    {
        key: MAIL_MENU_ITEM.DELETE,
        icon: undefined,
        group: '4',
        show: (mails, defaultShowFn) => {
            const mail = getMailFromMails(mails);
            if (getShowByFolder(mail, [FLOLDER.ADVITISE, FLOLDER.SPAM])) {
                return false;
            }
            return !!defaultShowFn && defaultShowFn(mail);
        },
    },
    {
        key: MAIL_MENU_ITEM.DELETE_WRAP,
        icon: undefined,
        group: '4',
        name: getIn18Text('SHANCHU'),
        onlyUnfold: true,
        show: mails => {
            const mail = getMailFromMails(mails);
            if (getShowByFolder(mail, [FLOLDER.ADVITISE, FLOLDER.SPAM])) {
                return true;
            }
            return false;
        },
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.DELETE,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.DIRECT_DELETE,
                icon: undefined,
            },
        ], DefaultMailMenuConfig),
    },
    {
        key: MAIL_MENU_ITEM.REPORT_TRUST,
        icon: undefined,
        group: '6',
    },
    {
        key: MAIL_MENU_ITEM.REPORT,
        icon: undefined,
        group: '6',
        show: taskMailMenuShow,
    },
    {
        key: MAIL_MENU_ITEM.TRANSLATE,
        icon: undefined,
        group: '6',
    },
    {
        key: MAIL_MENU_ITEM.SEARCH_IN_CONTENT,
        icon: undefined,
        group: '6',
    },
    {
        key: MAIL_MENU_ITEM.SHARE,
        icon: undefined,
        group: '7',
    },
    {
        key: MAIL_MENU_ITEM.DISCUSSION,
        icon: undefined,
        group: '7',
    },
], DefaultMailMenuConfig);
const MoreMenuConfig = [
    {
        key: MAIL_MENU_ITEM.SET_FROM_GROUP,
        icon: undefined,
        group: '8',
    },
    {
        key: MAIL_MENU_ITEM.CREATE_PERSONAL_GROUP,
        icon: undefined,
        group: '8',
    },
    {
        key: MAIL_MENU_ITEM.OPEN_IN_WINDOW,
        icon: undefined,
        group: '9',
    },
    {
        key: MAIL_MENU_ITEM.PRINT_MAIL_PREVIEW,
        icon: undefined,
        group: '9',
    },
    {
        key: MAIL_MENU_ITEM.PRINT_MAIL,
        icon: undefined,
        group: '9',
    },
    {
        key: MAIL_MENU_ITEM.EXPORT,
        icon: undefined,
        group: '9',
    },
    {
        key: MAIL_MENU_ITEM.ENCODING,
        icon: undefined,
        group: '9',
    },
    {
        key: MAIL_MENU_ITEM.EMAIL_HEADER,
        icon: undefined,
        group: '9',
    },
];
const estimateWidth = (mails, config) => {
    const paddingWidth = 12;
    const sunMenuIconWidth = 22;
    const otherWidth = paddingWidth * 2 + ((config === null || config === void 0 ? void 0 : config.subMenus) ? sunMenuIconWidth : 0);
    if (config) {
        let name = '';
        if (typeof (config === null || config === void 0 ? void 0 : config.name) === 'function') {
            name = config.name(mails) + '';
        }
        else {
            name = config.name + '';
        }
        if (typeof name === 'string') {
            return `${name}`.length * 12 + otherWidth;
        }
    }
    return 0;
};
const getAndMergeConfigWidth = (mails, config) => {
    if (config && config.length) {
        return config.map((item) => {
            let isShow = true;
            if (typeof item.show === 'function') {
                isShow = item.show(mails);
            }
            else {
                isShow = !!item.show;
            }
            return Object.assign(Object.assign({}, item), { _width: estimateWidth(mails, item), _isShow: isShow });
        });
    }
    return [];
};
const formatMenuAuto = (width, mails, noMore) => {
    const btnSpace = 8;
    const configList = [];
    const tempMoreConfigList = [];
    const menuConfig = getAndMergeConfigWidth(mails, ReadMailIconMenuConfig);
    if (menuConfig) {
        let sumWidth = 0;
        for (let i = 0; i < menuConfig.length; i++) {
            const curConfig = menuConfig[i];
            if (curConfig._isShow) {
                const curWidth = (curConfig._width || 0) + btnSpace;
                if (sumWidth + curWidth < width) {
                    configList.push(curConfig);
                }
                else {
                    tempMoreConfigList.push(curConfig);
                }
                sumWidth += curWidth;
            }
        }
    }
    configList.push({
        key: 'more',
        icon: undefined,
        group: '10',
        name: getIn18Text('GENGDUO'),
        onlyUnfold: true,
        show: true,
        subMenus: findAndMergeDefaultMenuConfig([...tempMoreConfigList, ...MoreMenuConfig], DefaultMailMenuConfig),
    });
    return configList;
};
const useReadMailIconMenuConfig = (toobarbox, mails, noMore) => {
    const [menuConfig, setMenuConfig] = useState([]);
    const [toobarWidth, setToobarWidth] = useState(0);
    const mergeDefaultMenuConfig = useMemo(() => findAndMergeDefaultMenuConfig(menuConfig, DefaultMailMenuConfig), [menuConfig]);
    const debouceSetToobarWidth = useDebounceForEvent(setToobarWidth, 500, { leading: false });
    useEffect(() => {
        if (!toobarbox) {
            return;
        }
        const resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                const { width } = entry.contentRect;
                debouceSetToobarWidth(width);
            }
        });
        resizeObserver.observe(toobarbox);
        return () => {
            resizeObserver.unobserve(toobarbox);
        };
    }, [lodashGet(toobarbox, 'tagName', '')]);
    useEffect(() => {
        if (mails) {
            setMenuConfig(formatMenuAuto(toobarWidth - 60, mails, noMore));
        }
    }, [toobarWidth, mails]);
    return mergeDefaultMenuConfig;
};
export default useReadMailIconMenuConfig;
